import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Luister naar SW-berichten (bv. notificationclick → navigeer naar url)
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    const msg = event.data;
    if (msg && msg.type === "navigate" && msg.url) {
      try { window.history.pushState({}, "", msg.url); window.dispatchEvent(new PopStateEvent("popstate")); } catch (_) {}
    }
  });
}

// Offline-queue auto-flush op online-event en app-start.
import { registerOfflineFlush } from "@/lib/offlineQueue";
registerOfflineFlush();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
